import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * ユーザーが所属するグループの一覧を取得する
 *
 * @param {string} apiToken - API呼び出しに使用するトークン
 * @param {object} apiParams - リクエストパラメータ
 * @param {Function} responseAction dispatch関数
 * @returns
 */
const getGroups = (apiToken, apiParams, responseAction) => dispatch => {
  consolelog('[API CALL] getGroups()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_GET_GROUPS;
  const { cancelToken, cancelTokenKey } = createCancelToken('getGroups');

  const axiosParams = {
    cancelToken,
    params: apiParams,
  };

  return axios
    .get(url, axiosParams)
    .then(res => {
      delCancelToken(cancelTokenKey);
      dispatch({
        type:
          (responseAction && responseAction) ||
          actionTypes.SUCCESS_API_GET_GROUPS,
        payload: res.data,
      });
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    });
};

export default getGroups;
